import React from 'react';

const NotificationConfigContext = React.createContext();

export default NotificationConfigContext;
